import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6723af59&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6723af59"]])

export default __exports__